export const name = 'rnSessionStorage';
/**
 * @ngdoc service
 * @name rhino.components.local-storage.service:rnSessionStorage
 * @description
 * Provides a simple facade over sessionStorage, allowing it to be easily
 * injected and testable.  Also simplifies storing and retrieving objects
 * instead of just strings.
 *
 * @example
 * ```js
 * rnSessionStorage.getString('marco'); // returns null
 * rnSessionStorage.setString('marco', 'polo');
 * rnSessionStorage.getString('marco'); // returns 'polo'
 *
 * rnSessionStorage.clear();
 * rnSessionStorage.getString('marco'); // returns null again
 *
 * rnSessionStorage.getObject('preferences'); // returns null
 * rnSessionStorage.setObject('preferences', {lang: 'en'});
 * rnSessionStorage.getObject('preferences'); // returns {lang: 'en'}
 *
 * rnSessionStorage.setString('notAnObject', 'notAnObject');
 * rnSessionStorage.getObject('notAnObject'); // throws JSON parse error
 * ```
 */
export default function($window) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let sessionStorage = $window.sessionStorage;

  let service = {
    getString: getString,
    setString: setString,
    getObject: getObject,
    setObject: setObject,
    removeItem: removeItem,
    clear: clear,
  };
  return service;

  ////////////////

  /**
   * @ngdoc function
   * @name getString
   * @methodOf rhino.components.local-storage.service:rnSessionStorage
   * @param {string} key to get
   * @returns {string} value `null` if not found
   */
  function getString(key) {
    return sessionStorage.getItem(key);
  }

  /**
   * @ngdoc function
   * @name setString
   * @methodOf rhino.components.local-storage.service:rnSessionStorage
   * @param {string} key to set
   * @param {string} str value to set
   */
  function setString(key, str) {
    sessionStorage.setItem(key, str);
  }

  /**
   * @ngdoc function
   * @name getObject
   * @methodOf rhino.components.local-storage.service:rnSessionStorage
   * @param {string} key to get
   * @returns {object} value `null` if not found
   */
  function getObject(key) {
    let item = getString(key);
    if(item === null) {
      return null;
    }
    return JSON.parse(item);
  }

  /**
   * @ngdoc function
   * @name setObject
   * @methodOf rhino.components.local-storage.service:rnSessionStorage
   * @param {string} key to set
   * @param {object} value to set
   */
  function setObject(key, obj) {
    setString(key, JSON.stringify(obj));
  }

  /**
   * @ngdoc function
   * @name removeItem
   * @methodOf rhino.components.local-storage.service:rnSessionStorage
   */
  function removeItem(key) {
    sessionStorage.removeItem(key);
  }

  /**
   * @ngdoc function
   * @name clear
   * @methodOf rhino.components.local-storage.service:rnSessionStorage
   */
  function clear() {
    sessionStorage.clear();
  }
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/session-storage/session-storage.service.js